export default "__VITE_ASSET__nfDmtfx$__"